// <copyright file="router.js" company="Microsoft Corporation">
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
// </copyright>

import * as React from "react";
import { HashRouter, Route, Routes } from "react-router-dom";
import AppInMeeting from "../components/app-in-meeting";
import Configure from "../components/configure";
import ShareToMeeting from "../components/share-to-meeting";
import * as microsoftTeams from "@microsoft/teams-js";
import ShareView from "../components/shareview";
import ChatPanel from "../components/chat-panel";
import WidgetPage from "../pages/WidgetPage";
import UserProfileManager from "../services/UserProfileManager";
import UsageLogService from "../services/UsageLogService";
import AuthTokenProvider from "../services/AuthTokenProvider";


export const AppRoute = () => {

    React.useEffect(() => {
        microsoftTeams.app
            .initialize()
            .then(async() => {
                console.log("App.js: initializing client SDK initialized");
                microsoftTeams.app.notifyAppLoaded();
                microsoftTeams.app.notifySuccess();

                try {
                    await AuthTokenProvider.initialize();
                    
                    // Get Teams context
                    const context = await microsoftTeams.app.getContext();

                    // Initialize User Profile FIRST (sequential, wait for completion)
                    console.log('[Router] Step 1: Initializing User Profile...');
                    await UserProfileManager.initialize();
                    console.log('[Router] Step 1: ✅ User Profile initialized');

                    // Initialize Usage Log Service SECOND (after profile is ready)
                    console.log('[Router] Step 2: Initializing Usage Log Service...');
                    await UsageLogService.initialize(context);
                    UsageLogService.enableAutoTracking();
                    console.log('[Router] Step 2: ✅ Usage Log Service initialized');

                } catch (error) {
                    console.warn('[Router] WARNING: Initialization failed:', error.message || error);
                }
            })
            .catch((error) => console.error(error));
    }, []);

    return (
        <React.Fragment>
            <HashRouter>
                <Routes>
                    <Route path="/" element={<ShareToMeeting />} />
                    <Route path="/appInMeeting" element={<AppInMeeting />} />
                    <Route path="/chat" element={<ChatPanel />} />
                    <Route path="/configure" element={<Configure />} />
                    <Route path="/shareview" element={<ShareView />} />
                    <Route path="/widget" element={<WidgetPage />} />
                </Routes>
            </HashRouter>
        </React.Fragment>
    );
};